import type { CourseType } from '../../../../../../resources/@types/courseSchema';
import { useVouchersMyUpcomingEventsQuery } from '../../../../../queries/useVouchersMyUpcomingEventsQuery';
import { UpcomingEventList } from './UpcomingEventList';

export function UpcomingEventListContainer({ courseType }: { courseType: CourseType }) {
  const { data } = useVouchersMyUpcomingEventsQuery({
    courseType,
  });

  const events = data?.items ?? [];

  if (events.length === 0) {
    return null;
  }

  return <UpcomingEventList events={events} />;
}
